/* eslint-disable react-hooks/rules-of-hooks */
import { observer } from "mobx-react";
import {
  Flex,
  Text
} from "@mantine/core";
import { useStore } from "../../../../hooks/use-store";
import { useRequest } from "ahooks";
import { NOTIFICATION_SERVICE } from "../../../../components/notifications/NotificationService";
import ImageObserved from "../Image";
import { PromptField } from "./PromptField";
import { PipelineParameters } from "../Pipeline";
import CanvasDraw from "react-canvas-draw";
import { useRef, useState, useEffect } from "react";
import { priceMap } from "../Router";

const Element = (model: {
  buy: (params: PipelineParameters[]) => Promise<void>;
  loading: boolean
}) => {

  const {
    dataStore: { spaceStore, appStore },
  } = useStore();

  const renderRef = useRef<CanvasDraw>(null);
  const [canvasHeight, setCanvasHeight] = useState(1024);
  const [canvasWidth, setCanvasWidth] = useState(800);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loading: runAsyncConvertBase64Loading, runAsync: runAsyncConvertBase64 } = useRequest(
    async (model: { url: string }) => appStore.convertImageBase64({
      url: model.url,
    }),
    {
      manual: true,
      onSuccess: (res) => {
        if (res.error) {
          NOTIFICATION_SERVICE.errorNotification(
            "Sorry, service is unavailable due to high demand. Please try later"
          );
        } else {
          return res.url
        }
      },
    }
  );

  useEffect(() => {
    if (spaceStore.selectedModel?.mainImage) {
      const img = new Image();
      img.onload = function () {
        const ratio = img.width / img.height;
        if (img.width > img.height) {
          setCanvasWidth(800);
          setCanvasHeight(800 / ratio);
        } else {
          setCanvasHeight(1024);
          setCanvasWidth(1024 * ratio);
        }
      };
      img.src = spaceStore.selectedModel.mainImage;
    }
  }, [spaceStore.selectedModel?.mainImage]);

  useEffect(() => {
    if (spaceStore.selectedImage) {
      const img = new Image();
      img.onload = function () {
        const ratio = img.width / img.height;
        if (img.width > img.height) {
          setCanvasWidth(800);
          setCanvasHeight(800 / ratio);
        } else {
          setCanvasHeight(1024);
          setCanvasWidth(1024 * ratio);
        }
      };
      img.src = spaceStore.selectedImage;
    }
  }, [spaceStore.selectedImage]);

  return (
    <Flex direction={'column'} w="100%" pos='relative' gap={12} mt={20} mb={60}>
      <Flex
        style={{
          position: 'absolute',
          top: '0',
          left: '50%',
          transform: 'translate(420px, 0)',
        }}
      >
        <Flex
          direction="column"
          gap={6}
          style={{
            width: '300px',
            position: 'relative',
            padding: '18px',
            backgroundColor: 'rgba(32, 32, 32, 1)',
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}
        >
          <Flex gap={8}>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.7821 8.0325C20.0721 8.7825 20.7921 9.3125 21.6421 9.3125C22.7421 9.3125 23.6421 8.4125 23.6421 7.3125C23.6421 6.2125 22.7421 5.3125 21.6421 5.3125C20.7921 5.3125 20.0721 5.8425 19.7821 6.5925C19.7321 6.5825 19.6921 6.5625 19.6421 6.5625H15.6421V5.8125C15.6421 4.9925 14.9621 4.3125 14.1421 4.3125H11.1421C10.3221 4.3125 9.64209 4.9925 9.64209 5.8125V6.5625H5.64209C5.59209 6.5625 5.55209 6.5825 5.50209 6.5925C5.21209 5.8425 4.49209 5.3125 3.64209 5.3125C2.54209 5.3125 1.64209 6.2125 1.64209 7.3125C1.64209 8.4125 2.54209 9.3125 3.64209 9.3125C4.49209 9.3125 5.21209 8.7825 5.50209 8.0325C5.55209 8.0425 5.59209 8.0625 5.64209 8.0625H8.21209C6.16209 9.5825 4.89209 12.1025 4.89209 14.8125C4.89209 14.9825 4.90209 15.1425 4.92209 15.3125H4.64209C3.81209 15.3125 3.14209 15.9825 3.14209 16.8125V18.8125C3.14209 19.6425 3.81209 20.3125 4.64209 20.3125H6.64209C6.86209 20.3125 7.06209 20.2625 7.25209 20.1725C7.77209 19.9525 8.14209 19.4225 8.14209 18.8125V16.8125C8.14209 15.9825 7.47209 15.3125 6.64209 15.3125H6.41209C6.41209 15.2825 6.42209 15.2525 6.42209 15.2225C6.40209 15.0825 6.40209 14.9525 6.40209 14.8125C6.40209 12.3425 7.67209 10.0825 9.66209 8.9125C9.70209 9.6825 10.3521 10.3125 11.1421 10.3125H14.1421C14.9321 10.3125 15.5821 9.6825 15.6321 8.9125C17.6221 10.0825 18.8921 12.3525 18.8921 14.8125C18.8921 14.9525 18.8821 15.0825 18.8721 15.2225C18.8721 15.2525 18.8821 15.2825 18.8821 15.3125H18.6421C17.8121 15.3125 17.1421 15.9825 17.1421 16.8125V18.8125C17.1421 19.4225 17.5121 19.9525 18.0321 20.1725C18.2221 20.2625 18.4221 20.3125 18.6421 20.3125H20.6421C21.4721 20.3125 22.1421 19.6425 22.1421 18.8125V16.8125C22.1421 15.9825 21.4721 15.3125 20.6421 15.3125H20.3621C20.3821 15.1425 20.3921 14.9825 20.3921 14.8125C20.3921 12.1025 19.1221 9.5825 17.0721 8.0625H19.6421C19.6921 8.0625 19.7321 8.0425 19.7821 8.0325Z" fill="#BDBDBD" />
            </svg>

            <Text color="white" size={'sm'} fw={700}>
              Workflow Info
            </Text>
          </Flex>
          <Text color="rgba(189, 189, 189, 1)" size={'sm'}>
            - Draw the are where you want to model to be applied
          </Text>
          <Text color="rgba(189, 189, 189, 1)" size={'sm'}>
            - Write a prompt describing the image you want to generate
          </Text>
          <Text color="rgba(189, 189, 189, 1)" size={'sm'}>
            - Click "Run" to generate the image
          </Text>
        </Flex>
      </Flex>
      <Flex w={'800px'} style={{
        position: 'relative',
      }}>
        <div
          style={{
            position: 'relative',
            zIndex: 1,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.2)',
          }}
        >
          <CanvasDraw
            ref={renderRef}
            backgroundColor='#00000028'
            lazyRadius={0}
            hideGrid={true}
            brushRadius={20}
            brushColor={'#ffff'}
            canvasHeight={canvasHeight}
            canvasWidth={canvasWidth}
          />
        </div>
        <ImageObserved
          style={{
            background: '#2424263f',
            position: 'absolute',
            borderRadius: '4px',
            left: 0,
            padding: 0,
          }}
          width={'800px'}
          height={'auto'}
          dark
          objectFit='cover'
          src={spaceStore.selectedModel?.mainImage || spaceStore.selectedImage!}
        />

      </Flex>

      {/* <ImageObserved
        src={spaceStore.selectedModel?.mainImage}
        width="100%"
        height="auto"
        imgStyle={{ borderRadius: '6px', overflow: 'hidden' }}
      >
      </ImageObserved> */}
      <Flex
        style={{
          position: 'absolute',
          right: '-320px',
          top: '300px',
          width: '300px',
          zIndex: 1000,
        }}
        id="sidebar"
      >
      </Flex>
      <PromptField
        credits={priceMap.INPAINT}
        onClick={async () => {
          if (renderRef) {
            const image = renderRef.current?.getDataURL('image/png', false, '#000')
            const { url } = await runAsyncConvertBase64({ url: image })
            console.log(url)

            const pipeline: PipelineParameters = {
              provider: 'custom',
              type: 'removeObject',
              prompt: spaceStore.prompt,
              inputSrc: spaceStore.selectedModel?.mainImage || spaceStore.selectedImage!,
              maskSrc: url,
              credits: priceMap.INPAINT,
              srcset: [],
            }
            await model.buy([pipeline])
          }
        }}
        value={spaceStore.prompt}
        onChangeEnd={(value) => {
          spaceStore.setPrompt(value)
        }}
        loading={model.loading}
        placeholder="Describe an image and click generate"
      >
        <Flex gap={8} p={10} wrap={'wrap'} pr={'100px'} w={'100%'}>

        </Flex>
      </PromptField>
    </Flex>
  );
};

export const Inpaint = observer(Element);